import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Badge } from "../components/ui/badge";
import { MapPin, Sparkles } from "lucide-react";
import useSEO from "../lib/useSEO";

const cats = ["security", "dj", "foodtruck", "lighting", "sound", "animation", "photography"];

export default function Providers() {
  const [providers, setProviders] = useState([]);
  const [category, setCategory] = useState("");

  useSEO({
    title: "Prestataires événementiels",
    description:
      "Trouvez le prestataire idéal pour votre événement en France : DJ, sécurité, food trucks, sonorisation, lumière, photographe, animation.",
  });

  useEffect(() => {
    api.get("/providers", { params: category ? { category } : {} }).then((r) => setProviders(r.data));
  }, [category]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <p className="text-label text-muted-foreground mb-3">Marketplace</p>
      <h1 className="font-heading font-light tracking-editorial text-4xl text-ink mb-8">
        Prestataires <em className="font-display text-accent">événementiels</em>
      </h1>

      <div className="flex flex-wrap gap-2 mb-10">
        <button
          data-testid="provider-cat-all"
          onClick={() => setCategory("")}
          className={`px-3 py-1.5 rounded-md text-sm transition-colors ${!category ? "bg-ink text-cream" : "bg-cream-100 hover:bg-cream-200"}`}
        >
          Tous
        </button>
        {cats.map((c) => (
          <button
            key={c}
            data-testid={`provider-cat-${c}`}
            onClick={() => setCategory(c)}
            className={`px-3 py-1.5 rounded-md text-sm capitalize transition-colors ${category === c ? "bg-ink text-cream" : "bg-cream-100 hover:bg-cream-200"}`}
          >
            {c}
          </button>
        ))}
      </div>

      {providers.length === 0 ? (
        <div className="bg-cream-50 border border-ink/10 rounded-md p-12 text-center">
          <p className="text-muted-foreground">
            Aucun prestataire pour cette catégorie.<br />
            Les prestataires peuvent s'inscrire via leur tableau de bord.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {providers.map((p) => {
            const img = p.images?.[0] || "https://images.unsplash.com/photo-1531058020387-3be344556be6?w=600";
            return (
              <Link
                key={p.id}
                to={`/providers/${p.id}`}
                data-testid={`provider-card-${p.id}`}
                className="bg-white border border-ink/10 rounded-md overflow-hidden hover:border-ink/30 transition-colors group"
              >
                <div className="aspect-[16/9] overflow-hidden bg-cream-100">
                  <img src={img} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-5">
                  <Badge variant="outline" className="mb-2 uppercase tracking-wider text-[10px]">{p.category}</Badge>
                  <h3 className="font-heading font-medium text-lg text-ink mb-1 group-hover:text-accent transition-colors">{p.name}</h3>
                  <p className="text-sm text-muted-foreground line-clamp-2 mb-3">{p.description}</p>
                  <div className="flex items-center gap-1.5 text-xs text-muted-foreground mb-3">
                    <MapPin className="h-3 w-3" /> {p.zone}
                  </div>
                  <div className="flex items-center justify-between pt-3 border-t border-ink/10">
                    <p className="font-heading font-black text-lg text-ink">{p.price_min}€ <span className="text-xs text-ink/40">–</span> {p.price_max}€</p>
                    <Sparkles className="h-4 w-4 text-accent opacity-0 group-hover:opacity-100 transition-opacity" />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
